import { useVizionarioStore } from "../store/useVizionarioStore";
import { showAlert } from "../utils/Alert";
import apiVizionario from "./apiVizionario";

const { REACT_APP_USE_TOKEN: USE_TOKEN } = process.env;

const handleVizionarioAuthResponse = async (responseData) => {
  const { token, user } = responseData;
  const { setUserData } = useVizionarioStore.getState();

  localStorage.setItem(USE_TOKEN, token);

  await setUserData(user);
};

export const logout = async () => {
  const { setUserData } = useVizionarioStore.getState();

  await apiVizionario.get("profile/logout");

  localStorage.removeItem(USE_TOKEN);
  setUserData(null);
};

export const getMembershipStatus = async () => {
  try {
    const response = await apiVizionario.get("profile/membership-status");
    return response.data;
  } catch (error) {
    console.error("Error vizionario membership status:", error);
    return null;
  }
};

export const login = async (email, password) => {
  const { setLoading, setIsVizionario, setIsCineFan, setIsAval, setShowLogin } =
    useVizionarioStore.getState();

  setLoading(true);

  const loginData = {
    email,
    password,
  };

  try {
    const response = await apiVizionario.post("login", loginData);
    await handleVizionarioAuthResponse(response.data);

    const membershipStatus = await getMembershipStatus();
    const { data } = membershipStatus;

    const membership = data[0];
    const isVizionario =
      membership.Estado.toLowerCase() === "usuario con tarjeta activa";
    const isCinefan = membership.CineFan.toLowerCase() === "vigente";

    if (!isVizionario) {
      logout();
      showAlert({
        title: "¡Lo sentimos!",
        text: "No tienes la cuenta del Club Vizionarios activa, por favor, adquierela en la taquilla",
      });
    } else {
      setIsVizionario(isVizionario);
      setIsCineFan(isCinefan);
      setIsAval(isVizionario && isCinefan);
      showAlert({
        title: "¡Bienvenido(a)!",
        text: "Disfruta de tu función",
        icon: "success",
      });
    }
  } catch (error) {
    showAlert({
      text: "Valida que tus datos sean correctos y que tengas una cuenta del Club Vizionarios activa",
    });
    console.error("Error vizionario login:", error);
  } finally {
    setLoading(false);
    setShowLogin(false);
  }
};
